import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import VisionSection5Image1 from '../../assets/vision_section5_image1.png';
import { HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H2, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

type VisionSection5Props = {
  isInView: boolean;
};

const VisionSection5 = ({ isInView }: VisionSection5Props) => {
  const { isMobile } = useDeviceType();
  const { horizontal: padding } = useResponsivePadding();
  const [imageAnimated, setImageAnimated] = useState(false);
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  useEffect(() => {
    if (isInView && !imageAnimated) {
      setImageAnimated(true);
    }
  }, [isInView, imageAnimated]);

  return (
    <VerticalLayout style={{ background: 'white', paddingLeft: padding, paddingRight: padding }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(160)}`} />
      <H2 style={{lineHeight: `${pxToRem(76)}`}}>Building brighter futures,<br />one pipe at a time</H2>
      <BTBox height={isMobile ? 16 : `${pxToRem(113)}`} />
      <HorizontalLayout>
        { !isMobile && <BTBox width='35%' />}
        <VerticalLayout style={{ width: isMobile ? '100%' : '65%' }}>
          <Text4 style={{opacity: 0.6,
          }}>
            <Trans i18nKey="우리의 비전은 세계가 FLOW SYSTEM을 바라보는 방식을 혁신하는 것입니다. 혁신에 대한 우리의 헌신을 통해, 우리는 효율적이고, 신뢰할 수 있는 최첨단 배관 솔루션을 제공함으로써 삶의 질을 향상시키고 지속 가능한 환경을 조성하는 것을 목표로 합니다. 이는 고도의 엔지니어링 능력과 지속 가능한 개발에 대한 깊은 헌신을 바탕으로, 업계 표준을 넘어서는 SMART FLOW을 제공함으로써 달성됩니다. 우리는 이러한 솔루션들이 에너지 효율을 높이고, 지속 가능한 환경을 만듦으로써, 사람들의 생활 방식에 긍정적인 영향을 미칠 것임을 확신합니다." />
          </Text4>
          <BTBox height={isMobile ? 16 : `${pxToRem(54)}`} />
          <div>
            <motion.img
              src={VisionSection5Image1}
              initial={{
                opacity: 1,
                rotateX: -90, // 바닥에 엎어진 상태
                transformPerspective: 1000, // 시점 거리
              }}
              animate={isInView ? {
                opacity: 1,
                rotateX: 0, // 정면
                transformPerspective: 1000,
              } : {}}
              transition={{
                duration: 0.9,
                ease: 'easeOut',
                delay: 0.3,
              }}
              style={{
                width: '100%',
                height: 'auto',
                transformOrigin: 'top center', // 바닥에서 들어올리는 느낌
                backfaceVisibility: 'hidden'
              }}
            />
          </div>
        </VerticalLayout>
      </HorizontalLayout>
      <BTBox height={`${pxToRem(241)}`} />
    </VerticalLayout>
  );
};

export default VisionSection5;
